import "./usernav.css";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { User, MapPin, LogOut, ShoppingBag } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { IoPerson } from "react-icons/io5";
import { MdOutlineMenuOpen } from "react-icons/md";
import { IoClose } from "react-icons/io5";

const Usernav = () => {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const phoneNumber = localStorage.getItem("phoneNumber");

  const [user, setUser] = useState({
    firstname: "",
    lastname: "",
    email: "",
    mob_number: phoneNumber,
    dob: "",
    password: "",
    profileImage: "",
  });

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("phoneNumber");
    localStorage.removeItem("role");
    alert("You have logged out successfully.");
    navigate("/login");
  };

  const handleProfileImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("profileImage", file);

    try {
      const response = await axios.post(
        `/api/profile/upload/${phoneNumber}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      setUser((prev) => ({
        ...prev,
        profileImage: response.data.imageUrl.split("/").pop(),
      }));
      alert("Profile image uploaded successfully!");
    } catch (error) {
      console.error("Upload failed:", error);
      alert("Failed to upload image");
    }
  };

  const handleDeleteProfileImage = async () => {
    if (!phoneNumber) return;
    const confirmDelete = window.confirm("Are you sure you want to delete your profile image?");
    if (!confirmDelete) return;

    try {
      await axios.delete(`/api/profile/image/${phoneNumber}`);
      setUser((prev) => ({ ...prev, profileImage: "" }));
      alert("Profile image deleted successfully.");
    } catch (error) {
      console.error("Error deleting image:", error);
      alert("Failed to delete image.");
    }
  };

  useEffect(() => {
    const fetchUser = async () => {
      if (!phoneNumber) return;
      try {
        const response = await axios.get(`/api/profile?phone=${phoneNumber}`);
        if (response.data) {
          setUser(response.data);
        }
      } catch (error) {
        console.error("Error fetching user", error);
      }
    };
    fetchUser();
  }, [phoneNumber]);

  return (
    <>
      <button className="toggle-sidebar-btn" onClick={toggleSidebar}>
        <MdOutlineMenuOpen />
      </button>

      <div className={`user-sidebar ${isSidebarOpen ? "mobile-visible" : "mobile-hidden"}`}>
        <div className="navcontiner">
          <button onClick={toggleSidebar} className="closebutton">
            <IoClose size={28} />
          </button>

          {/* Profile Image Section */}
          <div style={{ textAlign: "center", marginBottom: "15px" }}>
            {user.profileImage ? (
              <>
                <img
                  src={`/uploads/profile/${user.profileImage}`}
                  alt="Profile"
                  style={{
                    width: "80px",
                    height: "80px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    background: "#f3f3f3",
                  }}
                />
                <div style={{ marginTop: "6px" }}>
                  <label
                    htmlFor="editProfileImage"
                    style={{
                      fontSize: "11px",
                      color: "#007bff",
                      cursor: "pointer",
                      marginRight: "10px",
                    }}
                  >
                    Edit
                  </label>
                  <input
                    type="file"
                    id="editProfileImage"
                    accept="image/*"
                    onChange={handleProfileImageUpload}
                    style={{ display: "none" }}
                  />
                  <button
                    onClick={handleDeleteProfileImage}
                    style={{
                      fontSize: "11px",
                      color: "#dc3545",
                      border: "none",
                      background: "none",
                      cursor: "pointer",
                    }}
                  >
                    Delete
                  </button>
                </div>
              </>
            ) : (
              <>
                <IoPerson size={80} />
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleProfileImageUpload}
                  style={{ marginTop: "6px", fontSize: "11px", cursor: "pointer" }}
                />
              </>
            )}
            <li style={{ fontSize: "16px", fontWeight: "600", marginTop: "8px" }}>
              {user.firstname}
            </li>
          </div>

          {/* Menu Links */}
          <div className="dashboard">
            <ul style={{ listStyle: "none", padding: 0, marginTop: "10px", fontSize: "14px" }}>
              <li className="navitem" style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                <User size={18} style={{ marginRight: "10px" }} />
                <Link to="/userprofile" style={{ color: "black" }}>Profile</Link>
              </li>

              <li className="navitem" style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                <ShoppingBag size={18} style={{ marginRight: "10px" }} />
                <Link to="/userorder" style={{ color: "black" }}>Your Orders</Link>
              </li>

              <li className="navitem" style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                <MapPin size={18} style={{ marginRight: "10px" }} />
                <Link to="/Address" style={{ color: "black" }}>My Address</Link>
              </li>

              <li className="navitem" style={{ display: "flex", alignItems: "center", marginLeft: "2px" }}>
                <LogOut size={18} style={{ marginRight: "10px" }} />
                <Link to="/login" onClick={handleLogout} style={{ color: "black" }}>Logout</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default Usernav;
